import React from "react";
import { ButtonProps, Button, Icon } from "common";

export const GoBackButton: React.FC<ButtonProps> = (props) => (
	<Button {...props} className="btn-2 btn-md text-1 flex items-center space-x-2">
		{props.icon && <Icon type={props.icon} className="w-6 h-6" />}
		<span className="sr-only md:not-sr-only">{props.title}</span>
	</Button>
);
